import Emitter from "es6-event-emitter";
import i18n from "./../../../common/dictionary";
import logger from "./../../../common/utilities/logger";
import template from "./../templates/topBarComponent.dust";

var logoHomePath;
var logoReaderPath;
try {
  logoHomePath = require(`./../../../../clients/${process.env.CLIENT}/images/logo_home.png`);
} catch (error) {
  logoHomePath = require(`./../../../../clients/${process.env.CLIENT}/images/logo.png`);
}
try {
  logoReaderPath = require(`./../../../../clients/${process.env.CLIENT}/images/logo_reader.png`);
} catch (error) {
  logoReaderPath = require(`./../../../../clients/${process.env.CLIENT}/images/logo.png`);
}

export default class TopBarComponent extends Emitter {
  render(pointer, useToolTip = false, isReader = false) {
    const DOMContainer = document.querySelector(".top-bar-container");
    const context = {
      useCustomToolTip: useToolTip,
      isReader: isReader,
      i18n,
    };
    if (!DOMContainer) {
      logger.error("Node with class .top-bar-container not found");
      return;
    }
    Dust.render(template, context, (err, result) => {
      DOMContainer.innerHTML = result;
      const logo = DOMContainer.querySelector(".logo");
      const logoContainer = DOMContainer.querySelector(".top-bar-logo");
      if (pointer) {
        logoContainer.style.cursor = "pointer";
      }
      logo.onload = () => {
        this.trigger("topBar:rendered");
        logoContainer.addEventListener("click", () => {
          this.trigger("topBar:logoClicked");
        });
      };
      logo.onerror = () => {
        this.trigger("topBar:rendered");
      };
      const element = document.querySelector("#app-container");
      if (element && element.classList.contains("app-home")) {
        logo.src = logoHomePath;
      } else {
        logo.src = logoReaderPath;
        if (!useToolTip) {
          logo.setAttribute("title", i18n.readerLogoTooltip);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/web/shared/components/topBarComponent.js